export const reviewRowStyles = {
	row: {
		display: 'grid',
		gridTemplateColumns: '0.75fr 1fr 1fr',
		gap: 2,
		py: 1.5,
		borderBottom: '1px solid',
		borderColor: 'divider',
		'&:last-child': {
			borderBottom: 'none'
		}
	},

	fieldLabel: {
		fontSize: '0.9rem',
		fontWeight: 600,
		color: 'text.primary'
	},

	fieldValueOld: {
		fontSize: '0.9rem',
		color: 'text.secondary',
		wordBreak: 'break-word'
	},

	fieldValueNew: {
		fontSize: '0.9rem',
		fontWeight: 600,
		color: 'text.primary',
		wordBreak: 'break-word'
	}
};
